import { campaignStatusLabel } from '@interfaces/promotionCampaign/CampaignStatusEnum'

export function StatusBadge({ status }: { status: string }) {
  const label = campaignStatusLabel[status as keyof typeof campaignStatusLabel]

  const colorMap: Record<string, string> = {
    DRAFT: 'bg-gray-200 text-gray-700',
    PENDING: 'bg-yellow-100 text-yellow-700',
    APPROVED: 'bg-blue-100 text-blue-700',
    ACTIVE: 'bg-green-100 text-green-700',
    ENDED: 'bg-gray-100 text-gray-500',
    REJECTED: 'bg-red-100 text-red-700',
  }

  const color = colorMap[status] || 'bg-gray-100'

  return (
    <span
      className={`px-[10px] py-[4px] rounded-full text-[12px] font-medium ${color}`}
    >
      {label || status}
    </span>
  )
}
